import MuiSwitch, { SwitchProps } from '@mui/material/Switch';
import EDTooltip from '../Tooltip/EDTooltip';

interface IProps extends SwitchProps {
  testId?: string;
}

const EDSwitch = (props: IProps) => {
  const { title, testId, ...switchProps } = props;
  return title && title !== '' ? (
    <EDTooltip title={title}>
      <span>
        <MuiSwitch {...switchProps} data-testid={props.testId} />
      </span>
    </EDTooltip>
  ) : (
    <MuiSwitch {...switchProps} data-testid={props.testId} />
  );
};

export default EDSwitch;
